<form [formGroup]="weeklySlotsForm" (ngSubmit)="onSubmit()">

  <!-- FULL SCREEN LOADING POPUP -->
  <div
    *ngIf="isLoading"
    class="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 px-4"
  >
    <div class="w-full max-w-sm rounded-2xl bg-white p-6 text-center shadow-2xl">
      <div class="mx-auto mb-4 h-12 w-12 animate-spin rounded-full border-4 border-blue-200 border-t-blue-600"></div>

      <h3 class="text-base font-bold text-gray-900">
        Creating new slots
      </h3>

      <p class="mt-2 text-sm text-gray-600">
        Creating new slots. Please wait.
      </p>
    </div>
  </div>

  <div class="p-4">

    <input type="hidden" formControlName="rss_feed_id" />

    <!-- Social Platform -->
    <div class="mb-6 flex items-center gap-3 rounded-xl border border-gray-200 bg-gray-50 px-4 py-3">
      <mat-icon class="text-gray-400">share</mat-icon>
      <div>
        <div class="text-[10px] uppercase tracking-wide text-gray-400 font-semibold">Social Platform</div>
        <div class="text-sm font-semibold text-gray-800">
          {{ getPlatformName(weeklySlotsForm.get('social_platform_id')?.value) }}
        </div>
      </div>
    </div>

    <!-- Bulk time adder -->
    <div class="mb-6 rounded-2xl border border-gray-200 bg-gray-50 p-5">
      <div class="mb-4">
        <div class="text-sm font-semibold text-gray-900">Add time to selected days</div>
        <div class="text-xs text-gray-500 mt-0.5">Choose a time and apply it to one or more weekdays.</div>
      </div>

      <div [formGroup]="bulkTimeGroup" class="flex flex-col gap-4">

        <!-- Time picker row -->
        <div class="flex items-center gap-2">

          <select formControlName="hour"
            class="w-20 rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-300 cursor-pointer">
            <option *ngFor="let hour of hourOptions" [value]="hour">{{ hour }}</option>
          </select>

          <span class="text-gray-400 font-semibold text-lg">:</span>

          <select formControlName="minute"
            class="w-20 rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-300 cursor-pointer">
            <option *ngFor="let minute of minuteOptions" [value]="minute">{{ minute }}</option>
          </select>

          <!-- AM/PM toggle -->
          <div class="flex rounded-lg border border-gray-300 overflow-hidden bg-white">
            <button *ngFor="let ampm of ampmOptions" type="button"
              (click)="bulkTimeGroup.get('ampm')?.setValue(ampm)"
              class="px-3 py-2 text-sm font-semibold transition-all cursor-pointer"
              [ngClass]="bulkTimeGroup.get('ampm')?.value === ampm
                ? 'bg-blue-600 text-white'
                : 'text-gray-500 hover:bg-gray-100'">
              {{ ampm }}
            </button>
          </div>
        </div>

        <!-- Days row -->
        <div formGroupName="selectedDays" class="flex flex-wrap gap-2">
          <label *ngFor="let day of weekdays"
            class="flex items-center gap-1.5 px-3 py-1.5 rounded-full border text-xs font-semibold cursor-pointer transition-all"
            [ngClass]="bulkTimeGroup.get('selectedDays')?.get(day.value.toString())?.value
              ? 'bg-blue-600 text-white border-blue-600'
              : 'bg-white text-gray-600 border-gray-300 hover:border-blue-400'">
            <input type="checkbox" [formControlName]="day.value" class="hidden" />
            {{ day.name.slice(0, 3) }}
          </label>
        </div>

        <!-- Action -->
        <div>
          <button type="button" (click)="addBulkSlot()"
            class="cursor-pointer px-5 py-2 rounded-lg bg-blue-600 text-white text-sm font-semibold hover:bg-blue-700 transition-all">
            + Add Time
          </button>
        </div>

      </div>
    </div>

    <!-- Day slots grid -->
    <div formArrayName="slots" class="mb-6 grid grid-cols-1 md:grid-cols-2 gap-4">
      <div
        *ngFor="let dayGroup of slots.controls; let i = index"
        [formGroupName]="i"
        class="rounded-2xl border border-gray-200 bg-white p-4 shadow-sm">

        <div class="flex items-center justify-between mb-3">
          <div>
            <div class="text-sm font-semibold text-gray-900">{{ weekdays[i].name }}</div>
            <div class="text-xs text-gray-500">Available auto-schedule times</div>
          </div>

          <button type="button" (click)="clearDaySlots(i)"
            class="text-xs font-semibold text-rose-500 hover:text-rose-700 cursor-pointer transition-all">
            Clear
          </button>
        </div>

        <div class="flex flex-wrap gap-2" *ngIf="getDaySlots(i).length > 0; else noSlots">
          <div
            *ngFor="let slot of getDaySlots(i).controls; let j = index"
            [formGroup]="asFormGroup(slot)"
            class="inline-flex items-center gap-1.5 rounded-full bg-blue-50 px-3 py-1.5 text-xs font-semibold text-blue-700 border border-blue-100">
            <span>{{ formatSlotLabel(slot) }}</span>
            <button type="button" (click)="removeDaySlot(i, j)"
              class="cursor-pointer text-blue-400 hover:text-blue-700 transition-all leading-none">
              ✕
            </button>
          </div>
        </div>

        <ng-template #noSlots>
          <div class="rounded-xl border border-dashed border-gray-200 px-3 py-4 text-sm text-gray-400 text-center">
            No times added
          </div>
        </ng-template>
      </div>
    </div>

    <!-- Submit -->
    <div class="mt-6 flex justify-center">
      <button
        type="submit"
        [disabled]="isLoading"
        class="cursor-pointer rounded-lg bg-blue-600 px-8 py-2.5 text-sm font-semibold text-white shadow-sm transition-all hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-60"
      >
        {{ isLoading ? 'Saving...' : 'Save Weekly Slots' }}
      </button>
    </div>

  </div>
</form>